export const OrderFilter = {
  labelPlaceholder: 'Número do Pedido',
  labelBoPlaceholder: 'Nº Pedido BO'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/OrderFilter.js